"use strict";

import Dom from "common/Dom";
import * as handlers from "scripts/components/Overlay/handlers";
import * as handlers2 from "scripts/components/Scroll/handlers";

var getDropdownItem = function getDropdownItem($trigger) {
  return $trigger.closest(".nav-desktop__menu--item--dropdown");
};

export const openSubnav = function openSubnav($trigger) {
  var $item = getDropdownItem($trigger);
  $item.addClass("is-active");
  $trigger.attr("aria-expanded", "true");
  handlers2.scrollLock();
};

export const closeSubnav = function closeSubnav() {
  $(Dom.dropdownTrigger).attr("aria-expanded", "false");
  $(".nav-desktop__menu--item--dropdown").removeClass("is-active");
  handlers2.scrollUnlock();
};

export const toggleSubnav = function toggleSubnav($trigger) {
  var $item = getDropdownItem($trigger);
  if ($item.hasClass("is-active")) {
    closeSubnav();
  } else {
    closeSubnav();
    openSubnav($trigger);
  }
};

export const openMobileNav = function openMobileNav() {
  $(Dom.drawer).addClass("is-open");
  $(Dom.drawerTrigger).addClass("is-open").attr("aria-expanded", "true");
  handlers2.scrollLock();
};

export const closeMobileNav = function closeMobileNav() {
  $(Dom.drawer).removeClass("is-open");
  $(Dom.flyout).removeClass("is-open");
  $(Dom.drawerTrigger).removeClass("is-open").attr("aria-expanded", "false");
  $(Dom.flyoutTrigger).attr("aria-expanded", "false");
  $(Dom.promoBar).css("z-index", "100");
  $(Dom.drawer).css("z-index", "1");
  handlers2.scrollUnlock();
};

export const toggleMobileNav = function toggleMobileNav() {
  if ($(Dom.drawer).hasClass("is-open")) {
    closeMobileNav();
  } else {
    openMobileNav();
  }
};

export const openFlyout = function openFlyout($trigger) {
  $trigger.next($(Dom.flyout)).addClass("is-open");
  $trigger.attr("aria-expanded", "true");
  $(Dom.promoBar).css("z-index", "1");
  $(Dom.drawer).css("z-index", "100");
};

export const closeFlyout = function closeFlyout() {
  $(Dom.flyout).removeClass("is-open");
  $(Dom.flyoutTrigger).attr("aria-expanded", "false");
  $(Dom.promoBar).css("z-index", "100");
  $(Dom.drawer).css("z-index", "1");
};

export const toggleSearch = function toggleSearch() {
  $(Dom.mobileSearchForm).toggleClass("is-open");
};

export const mobileNavPadding = function mobileNavPadding() {
  var headerHeight = $(Dom.header).outerHeight();
  var promoBarHeight = $(Dom.promoBar).outerHeight();
  var htmlPosition = $("html")[0].style.top;
  var padding = void 0;
  if (parseInt(htmlPosition) < 0) {
    padding = headerHeight;
  } else {
    padding = headerHeight + promoBarHeight;
  }
  $(Dom.drawer).css("padding-top", padding);
};
